import NoResultsFoundImg from "@/assets/no-results.png";
import { Typography } from "@mui/joy";
import Stack from "@mui/joy/Stack";
import { SxProps } from "@mui/joy/styles/types";

interface Props {
  text?: string;
  subText?: string;
  icon?: string;
  size?: "sm" | "md" | "lg";
  sx?: SxProps;
}

const NotFoundFallback = ({ text, subText, icon, sx, size = "md" }: Props) => {
  const width = size === "sm" ? 80 : size === "md" ? 120 : 160;
  const height = size === "sm" ? 80 : size === "md" ? 120 : 160;
  return (
    <Stack
      alignItems={"center"}
      justifyContent={"center"}
      sx={[
        {
          flex: "1 1 0%",
          width: "100%",
          height: "100%",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      gap={2}
    >
      <img
        src={icon || NoResultsFoundImg}
        alt="no results found"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          objectFit: "contain",
        }}
      />

      <Typography level="title-lg" color="neutral" textAlign={"center"}>
        {text || "No items found"}
      </Typography>
      <Typography level="title-sm" color="neutral" textAlign={"center"}>
        {subText || ""}
      </Typography>
    </Stack>
  );
};
export default NotFoundFallback;
